import Marquee from 'react-fast-marquee';

const ITEMS = [
  'Tibetan Bakhu',
  'Tamang',
  'Rai',
  'Gurung',
  'Mangar',
  'Subba',
  'Limbu',
  'Newari · Pradhan',
  'Lepcha',
  'Dhaka Saree',
  'Choubandi Choli',
  'Bhutanese',
  'Made to Order',
];

export default function EditorialMarquee() {
  return (
    <section
      data-testid="marquee-section"
      className="border-y border-[color:var(--mb-border)] bg-[color:var(--mb-bg-alt)] py-8 overflow-hidden"
    >
      <Marquee speed={40} gradient={false} pauseOnHover>
        {ITEMS.map((it, idx) => (
          <span key={idx} className="marquee-item font-serif-display italic text-4xl sm:text-6xl text-[color:var(--mb-text)]">
            {it}
            <span className="marquee-dot" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
